import { render, staticRenderFns } from "./society.vue?vue&type=template&id=00057cc2&scoped=true&"
import script from "./society.vue?vue&type=script&lang=js&"
export * from "./society.vue?vue&type=script&lang=js&"
import style1 from "./society.vue?vue&type=style&index=1&id=00057cc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00057cc2",
  null
  
)

export default component.exports